module.exports = __webpack_public_path__ + "img/messages_messages-config-7.24b9dad7.jpg";